module.exports = __webpack_public_path__ + "img/grade_B.3e8fc7e.svg";